import { PartnerType } from 'legacy/lut/classes/models/PartnerType'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { fetchQBRDocuments } from 'partner360/components/QBR/api/fetchQBRDocuments'
import { fetchQBRUsersRole } from 'partner360/components/QBR/api/fetchQBRUsersRole'
import { setUserRole } from 'partner360/features/QBR'
import { selectQBRUserRole } from 'partner360/features/QBR/selectors/selectQBRUserRole'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

interface IUseFetchQbrDocumentsProps {
  partnerType: PartnerType
  myQbrValue: boolean
}

export const useFetchQbrDocuments = ({ partnerType, myQbrValue }: IUseFetchQbrDocumentsProps) => {
  const [data, setData] = useState<IQBRDocumentsListItem[]>([])
  const [initialData, setInitialData] = useState<IQBRDocumentsListItem[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const user = useSelector(selectUser)
  const dispatch = useAppDispatch()

  const userRole = useSelector(selectQBRUserRole)

  const fetchQbrDocuments = useCallback(async () => {
    setIsLoading(true)
    const res = await fetchQBRDocuments(partnerType, userRole)
    const resData = res.Data as IQBRDocumentsListItem[]
    setData(resData)
    setInitialData(resData)
    setIsDataLoaded(false)
    setIsLoading(false)
  }, [partnerType, userRole])

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchQBRUsersRole()
      const dataArray = response.Data
      const role = dataArray[0].RoleID
      dispatch(setUserRole(role))
    }

    fetchData()
  }, [dispatch])

  useEffect(() => {
    if (userRole) {
      fetchQbrDocuments()
    }
  }, [userRole, fetchQbrDocuments])

  useEffect(() => {
    if (!isDataLoaded && initialData.length) {
      setData(
        initialData.filter((el) => {
          return myQbrValue ? el.CreatedBy === user.id : true
        })
      )
      setIsDataLoaded(true)
    }
  }, [myQbrValue, isDataLoaded, user.id, initialData])

  return { data, setData, initialData, setInitialData, isLoading }
}
